import App from "./draftCompanion/App";
import { useEffect, useState } from "react";

function isNativeCapacitorShell() {
  if (typeof window === "undefined") return false;
  const capacitor = (window as any).Capacitor;
  return Boolean(capacitor?.isNativePlatform?.()) || window.location.protocol === "capacitor:";
}

function StartupLoadingScreen() {
  return (
    <div
      aria-live="polite"
      aria-busy="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 18,
      }}
    >
      <img
        src="/fantasydownloadlogo.png"
        alt="Fantasy Download"
        style={{
          width: "min(220px, 58vw)",
          height: "auto",
          display: "block",
        }}
      />
      <div
        style={{
          fontSize: 16,
          lineHeight: 1,
          fontWeight: 800,
          letterSpacing: 0,
          color: "rgba(255,255,255,0.86)",
        }}
      >
        Loading...
      </div>
    </div>
  );
}

export default function IosRoot() {
  const [showStartupLoading, setShowStartupLoading] = useState(() => isNativeCapacitorShell());

  useEffect(() => {
    if (!isNativeCapacitorShell()) {
      setShowStartupLoading(false);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setShowStartupLoading(false), 900);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <App />
      {showStartupLoading ? <StartupLoadingScreen /> : null}
    </>
  );
}
